export const defaultExamData = {
  mental_status: 'alert',
  behavior: '',
  posture: 'normal',
  posture_side: '',
  gait: 'normal',
  gait_side: '',
  gait_lf: '',
  gait_rf: '',
  gait_lh: '',
  gait_rh: '',
  ataxia_type: '',
  cn_i_olfactory: 'normal',
  cn_i_olfactory_side: '',
  cn_ii_optic: 'normal',
  cn_ii_optic_side: '',
  cn_ii_plr: 'normal',
  cn_ii_plr_side: '',
  cn_ii_plr_direct: 'normal',
  cn_ii_plr_direct_side: '',
  cn_ii_plr_indirect: 'normal',
  cn_ii_plr_indirect_side: '',
  cn_iii_oculomotor: 'normal',
  cn_iii_oculomotor_side: '',
  cn_iv_trochlear: 'normal',
  cn_iv_trochlear_side: '',
  cn_v_trigeminal_sensory: 'normal',
  cn_v_trigeminal_sensory_side: '',
  cn_v_trigeminal_motor: 'normal',
  cn_v_trigeminal_motor_side: '',
  cn_vi_abducens: 'normal',
  cn_vi_abducens_side: '',
  cn_vii_facial: 'normal',
  cn_vii_facial_side: '',
  cn_viii_vestibulocochlear: 'normal',
  cn_viii_vestibulocochlear_side: '',
  nystagmus_type: '',
  nystagmus_fast_phase: '',
  cn_ix_glossopharyngeal: 'normal',
  cn_ix_glossopharyngeal_side: '',
  cn_x_vagus: 'normal',
  cn_x_vagus_side: '',
  cn_xi_accessory: 'normal',
  cn_xi_accessory_side: '',
  cn_xii_hypoglossal: 'normal',
  cn_xii_hypoglossal_side: '',
  proprioception_lf: 'normal',
  proprioception_rf: 'normal',
  proprioception_lh: 'normal',
  proprioception_rh: 'normal',
  hopping_lf: 'normal',
  hopping_rf: 'normal',
  hopping_lh: 'normal',
  hopping_rh: 'normal',
  patellar_left: '+2',
  patellar_right: '+2',
  withdrawal_thoracic_left: '+2',
  withdrawal_thoracic_right: '+2',
  withdrawal_pelvic_left: '+2',
  withdrawal_pelvic_right: '+2',
  perineal_reflex: 'normal',
  cutaneous_trunci: 'normal',
  cutaneous_trunci_side: '',
  superficial_pain: 'present',
  superficial_pain_side: '',
  deep_pain: 'present',
  deep_pain_side: '',
  hyperpathia_location: '',
  notes: ''
};
